export default {
    current_choice: 'Obecny wybór',
    book_now: 'Zarezerwuj teraz',
    minimum_age: 'Tylko w wieku ponad {age}',
    excess_liability: 'Ubezpieczenie udziału własnego',
    security_deposit: 'Kaucja zabezpieczająca',
    fuel_policy: 'Zasady dotyczące paliwa',
    like_for_like: 'Podobny poziom',
    full_to_full: 'Pełny bak',
    miles_per_rental: '{mileage} bezpłatne mil(e) na wypożyczenie',
    km_per_rental: '{mileage} bezpłatne km na wypożyczenie',
    unlimited_mileage: 'Nieograniczony przebieg',
    unlimited_mileage_km: 'Bez limitu kilometrów',
    non_amendable: 'Nie podlega modyfikacji',
    non_refundable: 'Nie podlega zwrotowi',
    free_cancellation_until: 'Bezpłatne anulowanie przed',
    cancellation_in_line_with: 'Anulowanie zgodnie z',
    tcs: 'Regulaminem',
    free_extras_on_collection: 'Dwa bezpłatne dodatki przy odbiorze',
    glass_and_tyres_covered: 'Obejmuje szyby i opony',
    number_of_passengers: 'Liczba pasażerów',
    number_of_bags: 'Liczba poduszek',
    fuel_type: 'Rodzaj paliwa',
    co2: 'CO2',
    aircon: 'Klimatyzacja',
    transmission: 'Skrzynia biegów',
    book_type: 'Zarezerwuj {type}',
    debit_card_deposit: 'Karta debetowa akceptowana do wpłat',
    fast_track_included: 'Szybka ścieżka wliczona w cenę',
}
